import { clubStatus, DataVehicles, GetPersonUser } from '@esportal/portal-service';
import React, { useEffect, useLayoutEffect } from 'react';
import { useState } from 'react';
import { checkDateWithinDays } from '../../../helpers/common-helpers';

export const useNotificationsBar = (userData: GetPersonUser | null, userVehicles: DataVehicles | null) => {
	const notificationBarRef = React.useRef<HTMLDivElement | null>(null);
	const [isNotificationBarVisible, setIsNotificationBarVisible] = useState(false);
	const [notificationBarHeight, setNotificationBarHeight] = useState<number>(0);

	// Determina si la barra de notificación debe ser visible en función de los datos del usuario y los vehículos
	useEffect(() => {
		if (userData?.portalUser.data.clubVW.status === clubStatus.MEMBER && userVehicles) {
			setIsNotificationBarVisible(checkDateWithinDays(userData.portalUser.data.clubVW.fechaAltaClub, 30));
		}
	}, [userData?.portalUser.data.clubVW.status, userData?.portalUser.data.clubVW.fechaAltaClub, userVehicles]);

	// useEffect para gestionar la altura de la barra de notificación en función de su visibilidad
	useLayoutEffect(() => {
		if (!isNotificationBarVisible) {
			setNotificationBarHeight(0);
			return;
		}

		let frameId: number | undefined;

		const updateHeight = () => {
			const notificationBarElement = notificationBarRef.current;

			if (!notificationBarElement) {
				frameId = window.requestAnimationFrame(updateHeight);
				return;
			}

			setNotificationBarHeight(notificationBarElement.getBoundingClientRect().height);
		};

		updateHeight();
		window.addEventListener('resize', updateHeight);

		return () => {
			if (frameId) {
				window.cancelAnimationFrame(frameId);
			}
			window.removeEventListener('resize', updateHeight);
		};
	}, [isNotificationBarVisible]);

	return {
		isNotificationBarVisible,
		notificationBarHeight,
		notificationBarRef,
		setIsNotificationBarVisible,
	};
};
